export class LanguageUtil {
  static normaliseLanguage(language: string): string {
    return language.replace('-', '_');
  }
}
